__turbopack_context__.v({
  "formLabel": "label-module-scss-module__lx2EYa__formLabel",
});
